/* eslint-disable no-dupe-keys */
export default {
    welcome: "欢迎光临正雅网！",
    login: "登录",
    help: "帮助",
    register: "注册",
    registerSuccess: "注册成功",
    changePasswordSuccess: "密码修改成功",
    loginTitle: "登录页",
    registerTitle: "注册页",
    mine: "我的",
    username: "账号",
    password: "密码",
    forget: "忘记密码 ",
    phoneNumber: "手机号",
    inputCount: "用户名/手机号",
    mobile: "请输入手机号",
    refCode: "获取验证码",
    code: "验证码",
    inputPassword: "请输入密码",
    inputConformPassword: "请再次输入密码",
    passwordlg6: "密码不能低于6位!",
    hascount: "已有帐号",
    agreeIt: "注册默认“同意《正雅用户注册协议》”",
    verifynotise: "请填写验证码",
    passwordSame: "两次密码必须相同",
    passwordDiff: "两次输入密码不一致!",
    agree: "注册默认同意《正雅用户注册协议》",
    acount: "登录名",
    surname: "姓",
    name: "名",
    sex: "性别",
    male: "男",
    female: "女",
    expand: "展开",
    numberbetween: "请输入1~到128之间的数字",
    savesuccess: "保存成功",
    pleaseenteryourage: "请输入您的年龄",
    selectaddress: "请选择收货地址",
    collapse: "收起",
    incorrectage: "年龄有误",
    selecthospitalname: "请选择医院",
    enterlastgender: "请输入姓别",
    pleasetypeyourname: "请输入姓名",
    pleasetypeyourphone: "请输入手机号码",
    phonerror: "输入的手机号码不正确,请检查",
    filter: "筛选",
    email: "邮箱",
    medicalInstitution: "医院名称",
    selectyouarea: "请选择所在区域",
    selectyouareadetail: "所在区域请选择到区",
    zipCode: "邮编",
    hospitalAddress: "医院地址",
    finish: "完成",
    submit: "提交",
    cancel: "取消",
    deletesuccess: "删除成功！",
    isAuthentication: "已认证",
    unAuthentication: "未认证",
    enterusername: "请填写患者姓名",
    filltheusergender: "请填写用户性别",
    agevalue: "年龄必须为数字值",
    care: "关注",
    uncare: "取消关注",
    hadcare: "已关注",
    undone: "待处理",
    unsubmit: "待提交",
    sendtheverificationcode: "发送验证码",
    passwordupdated: "修改密码成功",
    done: "治疗中",
    resend: "s后重新发送",
    resendcode: "重新发送验证码",
    oldphonerules: "旧手机号码不能为空!",
    newphonerules: "新手机号码不能为空!",
    newphonesuccess: "修改手机号成功!",
    newphoneerror: "修改手机号不成功!",
    finished: "已完成",
    addPatient: "新建病例",
    patientName: "患者姓名",
    patientgender: "患者性别",
    patientNameRequired: "暂存失败，请在“基本信息”中填写患者姓名！",
    patientNameMsg: "请在“基本信息”中填写患者姓名！",
    hospitalNameMsg: "请在“基本信息”中选择医院名称！",
    addressMsg: "请在“基本信息”中选择收货地址！",
    SeriesMsg: "请在“产品选择”中选择产品系列！",
    angleMsg: "请在“错牙合类型”中选择安氏分类信息！",
    mismatchMsg: "请在“错牙合类型”中选择错牙合类型信息！",
    cashphotoMsg: "请在“照片上传”中上传必需的面相和口内照片！",
    casesumbit1Msg: "请在“病例提交单”中选择①主诉的信息！",
    casesumbit2Msg: "请在“病例提交单”中选择②矫治目标的信息！",
    casesumbit3Msg: "请在“病例提交单”中选择③矫治牙颌的信息！",
    casesumbit8Msg: "请在“病例提交单”中选择⑧矢状关系的信息！",
    casesumbit14Msg: "请在“病例提交单”中选择⑭中线的信息！",
    casesumbit15Msg: "请在“病例提交单”中选择⑮间隙矫治的信息！",
    casesumbit16Msg: "请在“病例提交单”中选择⑯拥挤矫治的信息！",
    toothmodelMsg: "请选择牙齿模型信息！",
    modelMsg: "请在“本地文件”中上传数字模型文件！",
    designdataMsg: "请上传设计数据文件，并填写上、下颌步数！",
    scanMsg: "请确认完成口扫操作！",

    patient: "患者",
    productLine: "产品系列",
    createTime: "创建日期",
    notiseTime: "提醒日期",
    clinicalOperation: "临床操作",
    caseProgress: "病例进度",
    notyetselected: "尚未选择产系",
    sustainedstorage: "产系暂存成功",
    allResult: "全部结果",
    yearold: "年龄",
    qingkuang: "检查情况",
    mark: "标记",
    all: "全部",
    features: "病例特征",
    orthodonticTreatment: "矫治方法",
    caseStatus: "病例状态",
    submitsuccess: "提交成功",
    enteraccount: "请输入帐号名",
    inputPatientName: "请输入患者姓名",
    inputReceiveAddress: "请输入收货地址",
    inputdetailAddress: "请输入详细地址",
    namecantberepeat: "姓名加地址在表格中已存在,不能重复!",
    scan: "一键口扫",
    createsuccess: "成功创建",
    givemelittletime: "请给我点时间！",
    scaning: "口扫中",
    zh: "中文",
    en: "English",
    es: 'Español',
    fr: 'Le français',
    screenfull: "全屏",
    size: "布局大小",
    selecttoothmodel: "至少选择一项牙齿模型",
    Pleaseselectfileupload: "请选择文件资料上传",
    dentalmodelsuspended: "牙齿模型暂存成功",
    uploadsuccess: "上传成功",
    messageType: "消息类型",
    messageContent: "消息内容",
    messageStatic: "消息状态",
    scanfile: "口扫文件",
    tooth: "排牙",
    toothfile: "排牙文件",
    transferredcases: "已转新病例",
    transfernewcases: "转新病例",
    usescan: "启动正雅一键口扫",
    smarteeusescan: "正雅一键口扫",
    resmarteeusescan: "重新口扫",
    previewusescan: "查看口扫",
    scanfilesuccess: "口扫文件上传成功",
    basemessage: "基本信息",
    selectionLines: "产品选择",
    mismatch: "错",
    mixfont: "牙合",
    mismatchType: "类型",
    photoUpload: "照片上传",
    otherPhotos: "其他照片",
    xUpload: "X光片上传",
    caseform: "病例提交单",
    storage: "暂存",
    next: "下一步",
    last: "上一步",
    required: "必选",
    toothmodel: "牙齿模型",
    previewandsubmit: "预览及提交",
    Malocclusiontype: "错𬌗类型", //𬌗 代码字符集代码E630 代表 颌字
    patientMessage: "患者信息",
    affiliatedHospital: "所属医院",
    contactNumber: "联系电话",
    receivingAddress: "收货地址：",
    smartee1: "Smartee GE 正雅",
    classicVersion: "经典款",
    smartee2: "Smartee Pre+ 极至",
    prideEdition: "尊享款",
    smartee3: "Smartee U+ 优加",
    youthVersion: "青少年款",
    angletype: "安氏分类",
    faceLeft: "面像侧位",
    faceLateral: "面像正位",
    faceSmile: "面像微笑",
    upperDentition: "上牙列",
    amplificationPhoto: "双击照片可以删除",
    lowerDentition: "下牙列",
    rightImage: "右侧位口内像",
    intraoralImage: "正位口内像",
    leftImage: "左侧位口内像",
    photosDel: "可批量上传照片，双击可删除",
    uploadPhotos: "上传照片",
    enterPhotoLocation: "请输入照片名称",
    title: "个人信息",
    phone: "手机",
    telephone: "固话",
    city: "城市",
    quality: "医生资格证书",
    addressmanagement: "地址管理",
    setting: "安全设置",
    childcountsetting: "子账号设置",
    preferences: "临床偏好",
    multipointPhysician: "多点执医",
    IsCase: "病例权",
    IsFinance: "财务权",
    casesStatistic: "病例统计",
    remark: "备注",
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeAll: "关闭所有",
    angle1: "安氏Ⅰ类",
    angle2: "安氏Ⅱ类",
    angle3: "安氏Ⅲ类",
    uncertain: "不确定",
    crowding: "拥挤",
    dentitionClearance: "牙列间隙",
    Protrusion: "前突",
    openjaw: "开𬌗",
    anteriorCrossbites: "前牙反𬌗",
    anterior: "前牙",
    rightTeeth: "右侧后牙",
    leftTeeth: "左侧后牙",
    posteriorCrossbite: "后牙反𬌗",
    deepCoverage: "深覆盖",
    deepOverbites: "深覆𬌗",
    other: "其他",
    writeinstructions: "在特殊说明里写明",
    surfaceFault: "曲面断层",
    lateralCranium: "头颅侧位",
    uploadCBCT: "上传CBCT",
    uploadFiles: "上传文件",
    choseModelFiles: "请选择数字模型文件",
    browse: "浏览",
    otherXray: "其他X光片上传",
    inputOtherXray: "请输入X光片位置信息",
    chiefComplaint: "主诉",
    addnotes: "添加备注",
    unevenTeeth: "牙齿不齐",
    siliconerubberstamp: "硅橡胶印",
    diastema: "牙间隙",
    dentalProtrusion: "牙前突",
    dentofacialJaw: "反𬌗",
    majorObjectives: "主要矫治目标",
    arrangeTeeth: "排列牙齿",
    closingDentitionSpace: "关闭牙列间隙",
    improvementProfile: "改善前突面型",
    orthodonticTeeth: "拟矫治牙颌",
    orthodonticsDescribe: "(即使单颌矫治，也需要提交全颌硅橡胶印模或数字文件)",
    wholeJaw2: "全颌",
    maxillary: "上颌",
    mandible: "下颌",
    toothInformation: "牙齿信息",
    toothnotise: "注：缺牙为灰色，乳牙为绿色。若勾选乳牙，则X光为必选。",
    noDeletion: "无缺失",
    noDeciduousTeeth: "无乳牙",
    deciduousTeeth: "以下牙齿为乳牙",
    teethmiss: "以下牙齿缺失",
    submitTeethModel: "请提交牙齿模型",
    faceShape: "面型",
    siliconeRubberModel: "硅橡胶模型",
    siliconeRubberImpression: "硅橡胶印模",
    siliconeRubberRecord: "硅橡胶印模+咬合记录",
    courierCompany: "快递公司编号",
    courier: "快递单号",
    refCn: "病例ID：",
    couriercompany: "快递公司",
    courierNumber: "请输入快递单号",
    seachCourier:
        "输入快递单号后可回车进行查询快递信息，也可点击按钮查询快递信息",
    courierNotise:
        "注：为了您能更快得到设计动画和矫治器，请务必填写快递单号或邮寄模型时附上该病例的ID号",
    modelFiles: "数字模型文件",
    localFile: "本地文件",
    shape3: "3Shape/西诺德口扫数据",
    notImg: "该文件不是图片文件",
    wrongformat: "不支持此种图片格式",
    compressionerror: "不支持此种压缩格式",
    upload: "上传",
    reupload: "重新上传",
    uploading: "上传中",
    uploadfailed: "上传失败",
    fileupload: "文件上传",
    mouthdata: "口扫数据",
    mattersNeedingAttention: "注意事项",
    includeScans: "2:必须包含上、下颌及咬合扫描记录；",
    includeZip: "3:以压缩包形式上传（文件类型必须是 .rar/.zip）。",
    shape: "3Shape",
    shape3web: "1:登录3Shape网站,as1.3Shapecommunicate.com",
    loginsironaaccount: "1:登录您西诺德账户",
    shape3user: "2:输入您的3Shape用户名和密码",
    shape3qq:
        "3:添加正雅公司账户“kousao@smartee.cn”，将通过TRIOS扫描出的数据发送到该账户",
    oemnotise:
        "注：设计数据为OEM代工专用，只需填写“基本信息”及“产品选择”两项内容。",
    sinold: "西诺德口扫数据",
    textareatip:
        '其他情况请限制在1000字以内（误删除点后，使用"ctrl+z"撤销操作)',
    sinoldCount: "登录您的西诺德账户",
    addSmarteeCount: "2:添加正雅公司账户“Smartee”，将扫描出的数据发送到该账户",
    sendEmail:
        "1:可发送zip、rar、stl文件至 kousao@smartee.cn 。邮件标题请写“机构名+医生名+患者名”。",
    patientDetails: "患者详情",
    patientHome: "患者主页",
    deliveryRequirements: "发货要求",
    oneTimeDelivery: "一次性发货",
    phasedDelivery: "分阶段发货",
    endTherapy: "结束治疗",
    lateHolderShipped: "后期保持器已发货",
    expressType: "快递类型：",
    logisticsNumber: "物流单号：",
    lateStageDelivery: "后期保持器发货预计",
    endTreatmentConfirmed: "结束治疗已确认",
    laterStageHolderProcessing: "后期保持器加工中",
    estimatedDelivery: "后期保持器预计发货时间",
    confirmationTreatment: "结束治疗确认",
    see: "查看",
    fineTuning: "精调",
    productionStage: "生产阶段",
    delivery: "发货",
    firstStage: "首阶段",
    appliancesShipped: "矫治器已发货",
    steps: "步数",
    oem: "OEM代工",
    Medicalinstitutions: "医疗机构:",
    ordernumber: "订单编号",
    maxillarySteps: "上颌步数",
    mandibularSteps: "下颌步数",
    totalMaxillarySteps: "上颌总步数：",
    totalMandibularSteps: "下颌总步数：",
    numberDeliverySteps: "本次发货步数：",
    ShipmentForecast: "发货预计",
    Thenumberofstepsinthisshipment: "本次发货申请步数:",
    FineTuningDesignConfirmed: "精调设计已确认",
    ProcessingFineTuned: "精调矫治器加工中",
    // totalMaxillarySteps: "精调矫治器预计发货时间",
    finelyAdjustDeliveryTime: "矫治器预计发货时间",
    designPhase: "设计阶段",
    processing: "精调阶段",
    postWarranty: "后保",
    design3D: "3D设计",
    unconfirm: "未确认",
    confirmed: "已确认",
    abandon: "放弃",
    designSN: "设计编号",
    designTime: "设计时间",
    confirm: "确认",
    quotation: "报价单",
    receivingInspection: "收件检查",
    checkQualified: "检查合格",
    unqualified: "检查不合格",
    nonconformitynotice: "不合格通知单",
    modelReceived: "模型已接收",
    fineTunedCasesSubmitted: "精调病例已提交",
    fineTunedCasesTobeSubmit: "精调病例待提交",
    fineTunedCasesStorage: "精调计划暂存",
    completeInformation: "资料待完善，请补充完整",
    rearrangingTeeth: "重新排牙",
    ViewTooth: "查看排牙",
    followUpConfirmed: "加工后续申请已确认",
    followUpApplication: "加工后续已申请",
    followUptoComform: "加工后续待确认",
    followUpTime: "预计矫治器后续加工时间",
    residualAppliance: "后续矫治器",
    vice: "副",
    backPatiant: "返回病例详情",
    designConfirmed: "设计动画已确认",
    clinicalDoctorsModifications: "临床医生提出修改意见",
    tobeConfirmed: "待确认",
    casesSubmitted: "病例已提交",
    casesTobeSubmit: "病例待提交",
    impactData: "影像资料",
    group: "组",
    caseInformation: "病例资料",
    proceduresStage: "本阶段第",
    proceduresStage1: "步需要临床操作",
    proceduresNotStage: "本阶段暂无临床操作",
    fineAdjustment: "精细调整",
    processingFollowUp: "加工后续",
    finelyTunedCaseSubmissionForm: "精调病例提交单",
    currentAppliancesFit: "当前矫治器贴合情况",
    applianceFit: "矫治器贴合",
    judgementBasis:
        "判断依据：牙齿移动及咬合关系与模拟矫治器设计基本符合，矫治器与牙齿之间无明显空隙。",
    appliancesUnfit: "矫治器不贴合",
    needmodelfile: "需提交全口硅橡胶印模，或全口数字模型文件。",
    defaultGrind:
        "取硅胶前请磨出口内所有附件；如未磨除，我司将默认按磨除处理。",
    clinicalExamination: "临床检查",
    orthodonticSteps: "本次反馈时佩戴矫治器步数为：",
    isDentitionSpace: "有无牙列间隙",
    none: "无",
    have: "有",
    left: "左",
    right: "右",
    clearanceCheck:
        "当前牙列间隙检查（请用间隙测量尺准确测量）：注：间隙最多2位小数，间隙单位mm",
    otherCheck: "其他检查（包括牙齿错位，松动，早接触度等）",
    otherLimited:
        "其他情况请限制在1000字以内（误删除后，使用Ctrl+z撤销操作）。",
    designRequirement:
        "前一个阶段的设计要求（如有变更请医生及时调整，如不修改公司将延续前一个阶段的设计要求）",
    NonRemovableTeeth: "不可移动牙齿",
    NonRemovableTeethType: "(烤瓷牙，修复桥体，种植牙等无法移动牙齿)",
    followingTeethImmovable: "以下牙齿不可移动",
    notDesigned: "不可设计附件牙齿",
    notDesignedType: "(烤瓷牙，修复桥体等无法粘贴附件)",
    NonRemovableDesign: "以下牙齿不可设计附件",
    FlatGuidePlateTeeth: "前牙平导板",
    suitableCase: "适用于深覆𬌗浅覆盖病例",
    suitableCase2: "浅覆盖病例",
    anteriorCentralIncisor: "前牙中切牙",
    LateralIncisorsAnteriorTeeth: "前牙侧切牙",
    anteriorTeeth2: "前牙尖牙",
    longDistanceTreatment: "是否远程矫治",
    selectYes: "(注：若勾选是，将会在初次3D设计将合并所有临床操作至第一步)",
    yes: "是",
    no: "否",
    cover: "覆盖",
    every3mothsVisit: "每3个月复诊一次",
    every6mothsVisit: "每6个月复诊一次",
    every12mothsVisit: "每12个月复诊一次",
    secondVisit: "复诊一次",
    unableDetermineReferralPeriod: "无法确定复诊周期",
    followUpOrthodontic: "后续矫治要求（不应改变初始矫治目标）",
    limited: "请输入1000字以内",
    unfitPhotographs: "佩戴矫治器不贴合部位照片",
    unfit: "不贴合",
    images: "图片",
    photographs: "口内照",
    photoface: "面相照",
    xphoto: "X光片",
    wholeJaw: "全颌曲面断层片",
    cephalometric: "头颅侧位定位片",
    submitDataModel: "请提交完整清晰的数字模型",
    viewingModelRequirements: "查看模型要求",
    boxScanFile: "箱扫文件",
    saveSTL: "1:保存格式为STL格式",
    scanList: "必须包含咬合扫描记录",
    save: "保存",
    doctorSignature: "医生签名",
    date: "日期",
    completionOrthodonticTreatment: "矫治完成情况",
    whichBelongs: "确认完成属于哪种情况",
    achievingCorrectionObjectives: "实现矫治目标",
    changeOtherMethods: "隐形矫治达到阶段效果，改用其他矫治方法完成",
    unfinishIquiredOver: "未完成实现隐形矫治目标，但患者要求结束矫治",
    inputOthers: "请在输入框内填写其他原因",
    finishedPhotos: "矫治完成后照片",
    postWarrantyData: "后保资料",
    letterAuthorization: "同意书",
    currentPatientName: "当前患者姓名",
    hospital: "医院",
    clinic: "诊所",
    letterSmartee: "同意《隐形矫治结束同意书》",

    letterPrint: "打印隐形矫治结束同意书",
    canvasDesign: "动画设计",
    canvasView: "动画查看",
    gums: "牙龈",
    workSpace: "工作面",
    contrast: "对比",
    occlusion: "咬合",
    enclosure: "附件",
    grid: "网格",
    designCommunication: "设计沟通",
    distributionInformation: "分布信息",
    operation: "操作说明",
    inputEdit: "请在此输入修改意见",
    agreeProgramme: "请使用右上角的批准按钮同意矫治方案",
    mockProgramme: "模拟方案",
    effectDifferent: "实际治疗效果可能不同",
    animationContrast: "动画对比",
    transferCases: "保存并转新病例",
    scanRescan: "正雅口扫重新扫描",
    mk: "MK",
    mainPages: "主界面",
    UnderTenyears: "10岁以下",
    from10to20: "10-20岁",
    from21to30: "21-30岁",
    from31to40: "31-40岁",
    over41: "41岁以上",

    interproximalEnamelStripping: "邻面去釉",
    distalMolars: "远移磨牙",
    classTraction: "Ⅱ/Ⅲ类牵引",
    extendedAnteriorTeeth: "伸长前牙",
    lowerFrontTeeth: "压低前牙",
    archExpansion: "扩弓",
    pressDown: "压低前牙并升高前磨牙",
    lipMoveUp: "唇移上前牙",
    tongueMovedown: "舌移下前牙",
    maxillaryAnteriorTeeth: "伸长上颌前牙",
    mandibleAnteriorTeeth: "伸长下颌前牙",
    improveMidline: "改善中线",
    midline: "中线",
    improvementMaxillaryProtrusion: "改善上颌前突",
    improvementMaxillaryRetraction: "改善上颌后缩",
    improvementMandibularProtrusion: "改善下颌前突",
    improvingMandibularRetraction: "改善下颌后缩",
    sagittalRelationship: "矢状关系",
    allJawSilicone: "即使单颌矫治，也需提交全颌硅橡胶印模或数字文件",
    improve: "改善",
    maintain: "维持",
    firstChoice: "首选",
    overlay: "覆𬌗",
    optional: "可选",
    notAllowed: "不可",
    rightUpper: "右上",
    leftUpper: "左上",
    xRayRequired: "注：若勾选，则X光为必选",
    maintainingImprovingRelationship: "维持改善牙关系",
    caninesMolars: "改善尖牙和磨牙关系",
    caninesfangs: "仅改善尖牙关系",
    adjustmentNeutrality: "调整到中性关系",
    moreAdjacentGlazing: "(可能需较多邻面去釉或拔牙)",
    maintainMidline: "维持中线",
    maybeRequerEnamelStripping: "(可能需要邻面去釉)",
    lefttoPatient: "向患者左",
    correctionGap: "间隙的矫治",
    increaseDesigns: "(可能会增加3D设计的修改时间和次数)",
    righttoPatient: "向患者右",
    noSpaceReserved: "不预留间隙",
    spaceReserved: "预留间隙",
    adduction: "前牙内收",
    NearPosteriorTooth: "后牙近移",
    adductionNearPosteriorTooth: "前牙内收,后牙近移",
    lipTilt: "唇倾",
    toothExtraction: "拔牙",
    notoothExtraction: "不拔牙",
    correctionCrowding: "拥挤的矫治",
    followingTeeth: "拔除以下牙齿",
    methods: "方法",
    intermaxillaryTraction: "需配合颌间牵引",
    caseBank: "病例库",
    marketActivity: "市场活动",
    messageNotification: "消息通知",
    messageDetail: "消息明细",
    wornOut: "矫治器即将戴完",
    canvasModified: "动画方案已修改",
    fixedTel: "固定电话",
    definition3Ddesign: "3D设计后再确定",
    othersSpecified: "其他（在特殊说明里写明）",
    openOcclusion: "纠正开𬌗",
    deepOverbite: "纠正深覆𬌗",
    overbite: "覆𬌗",
    backtop: "返回顶部",
    onlyanteriorTeeth: "只压低前牙",
    receiveName: "收件人",
    region: "地区",
    addressDetail: "详细地址",
    telphone: "联系方式",
    default: "默认",
    invoiceAddress: "发票邮寄地址",
    loginPassword: "登录密码",
    verifyphone: "验证手机",
    anteriorTeeth: "前牙对刃𬌗",
    anteriorCrossbite: "前牙反𬌗",
    posteriorTeeth: "后牙反𬌗或锁𬌗",
    posteriorTeeth2: "或锁",
    exist: "(如果存在)",
    addSubaccounts: "增加子账号",
    editSubaccounts: "编辑子账号",
    subaccountName: "子账号用户名",
    subaccountPassword: "子账号密码",
    shippingaddress: "收货地址",
    access: "访问权限",
    availability: "是否可用",
    notRectify: "不纠正",
    correct: "纠正",
    rectify: "纠正反𬌗",
    designValidation: "设计确认，设计分享，提交沟通意见",
    editcase: "编辑病例提交单，确认收货，结束治疗",
    sheetView: "报价单查看",
    maybe: "是否可以",
    specialInstructions: "特殊说明",
    wisdomTooth: "智齿",
    defaultRemoval: "默认拔除（矫治器不覆盖）",
    requirements: "根据方案要求",
    glazeRemoval: "去釉",
    glazeRemovalPositon: "去釉位置",
    frontTeethFirst: "前牙优先",
    posteriorTeethPreferred: "后牙优先",
    beautifulDentition: "美观牙列",
    unwanted: "不需要",
    need: "前牙区间隙大于4mm时需要",
    attachment: "操作及附件粘贴",
    doing: "进行",
    DelayStep: "推迟至",

    systemhelp: "系统帮助",
    tips: "提示",
    consultation:
        "您尚未安装正雅口扫软件，请联系与您对接的客服或销售进行咨询！",
    feeConfirmationForm: "正雅无托槽隐形矫收费确认单",
    back: "返回",
    specificationTable: "说明表",
    confirmationAgreement: "确认协议",
    scanApp: "扫一扫，下载Smartee隐形矫治手机APP",

    semail: "邮件发送",
    fineTuned: "矫治器加工中",
    followTitle: "后续加工",
    deliveryTotal: "发货阶段",
    Totaldeliveryphase: "发货阶段共",
    total: "总",
    Times: "次",
    First: "第",
    this: "本次申请",
    stage: "阶段",
    deliveryTime: "预计下次加工时间为",
    fineTunedCases: "精调病例",
    submitted: "已提交",
    clickUpload: "点击修改",
    secret: "保密",
    edit: "编辑",
    add: "新增",
    isDefault: "是否默认",
    zhengyakousweepdata: "正雅口扫数据",

    requiredPhone: "帐号不能为空",
    requiredPhone11: "手机号不允许小于11位",
    requiredRightPhone: "请输入正确的手机号!",

    requiredPassword: "密码不能为空",
    requiredPasswordLg6: "密码不能小于6位",

    requiredCode: "验证码不能为空",
    requiredCodelg6: "验证码最长是6位",

    errorSubmit: "提交不成功！",
    sendSuccess: "发送成功！请查收",
    sendError: "发送不成功！请重发送",
    resetPassword: "重置密码",
    requiredEmail: "请输入正确的邮箱地址",
    choose: "请选择",
    introduction: "简介",
    baseInfo: "基本资料",
    city: "省市区",
    oldPassword: "旧密码",
    newPassword: "新密码",
    changeSuccess: "修改成功",
    checkPass: "确认密码",
    oldphone: "旧手机号",
    newphone: "新手机号",
    Name: "姓名",
    editRow: "操作",
    addInvoiceAddress: "新增发票邮寄地址",
    addAddress: "新增收货地址",
    editInvoiceAddress: "修改发票邮寄地址",
    editAddress: "修改收货地址",
    inputHospitalName: "请输入医院名称",
    inputHospitalAddress: "请输入医院地址",
    inputEmail: "请输入邮箱地址",
    casesn: "ID",
    casecode: "病例号",
    age: "岁",
    rightdown: "右下",
    leftdown: "左下",
    over2m: "2mm以上",
    isrequerdtosmartee: "是否与正雅医学部进行方案沟通",
    isMSGRead: "已读",
    isMSGunRead: "未读",
    sysNotise: "系统提醒",
    processNotise: "进度提醒",
    stepsNotise: "阶段提醒",
    patientGender: "请选择性别",
    inputpatientAge: "请输入年龄",
    isCase: "病例管理",
    isDesign: "设计管理",
    isTreat: "治疗管理",
    isFinance: "财务管理",
    isCasedes: "病例管理-新建病例，一键口扫",
    isDesigndes: "设计管理-设计确认，设计分享，提交沟通意见",
    isTreatdes: "治疗管理-编辑病例提交单，确认收货，结束治疗",
    isFinancedes: "财务管理-报价单查看",
    onlyready: "只看",
    designData: "设计数据",
    trackItems: "物流信息",
    inputSearch: "输入患者姓名、ID、病例号",
    doctor: "医生",
    personalCenter: "个人中心",
    home: "首页",
    logout: "退出",
    noOperation: "近期暂无临床操作",
    otherPhotos1: "其他1",
    otherPhotos2: "其他2",
    shaporironasweep: "3cshap/西诺德口扫",

    // 用户协议
    userAgreementTitle: "《正雅用户协议》",
    userAgreementAlert: " 重要提示：",
    userAgreementDes:
        " 您通过上海正雅齿科科技有限公司（以下简称“正雅”）的正雅病例管理系统（以下简称“系统”）进行病例提交及使用其他功能之前，请您务必审慎阅读、充分理解本协议各条款内容，包括但不限于免除或者限制责任的条款。如您不同意本协议及/或随时对其的调整修订，您可以主动停止使用正雅系统提供的服务；您一旦使用该项服务，即视为您已了解并完全同意本协议各项内容，包括正雅对服务协议随时所做的任何修改，并成为正雅用户。",
    userAgreement100: " 一、总则",
    userAgreement110:
        " 1.1 用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序中点击'同意'按钮即表示用户与正雅达成协议，完全接受本协议项下的全部条款。",
    userAgreement120:
        " 1.2 用户注册成功后，该帐号和密码由用户负责保管；用户应当对以其帐号进行的所有活动和事件负法律责任。",
    userAgreement200: " 二、注册信息与隐私保护",
    userAgreement210:
        " 2.1 正雅系统帐号及帐号中所有虚拟物品所有权归正雅。用户按注册页面引导填写信息，阅读并同意本协议且完成全部注册程序后，即可成为正雅用户。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实或更新不及时而引发的相关问题，正雅不负任何责任。用户应当通过真实身份信息认证注册账号，且用户提交的账号名称、头像和简介等注册信息中不得出现违法和不良信息，经审核，如存在上述情况，正雅将不予注册；同时，在注册后，如发现用户以虚假信息骗取账号名称注册，或其账号头像、简介等注册信息存在违法和不良信息的，正雅有权不经通知单方采取限期改正、暂停使用、注销登记、收回等措施。",
    userAgreement220:
        " 2.2 经系统完成注册程序，成为正雅的正式用户，即获得正雅规定用户所应享有的一切权限；正雅有权对其正式用户的权限设计进行变更。",
    userAgreement230:
        " 2.3 用户注册时不得以下列内容作为帐号名称，如发现用户帐号中含有不雅文字或不恰当名称的，正雅保留取消其用户资格的权利。",
    userAgreement231:
        " (1) 以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；",
    userAgreement232: " (2) 以国家机构或其他机构的名称注册；",
    userAgreement233:
        " (3) 以不文明、不健康名字，或包含歧视、侮辱、猥亵类词语注册；",
    userAgreement234:
        " (4) 以易产生歧义、引起他人误解或其它不符合法律法规、规章制度等规定注册。",
    userAgreement240:
        " 2.4 除正雅服务条款注明之服务条款外，其他一切因使用正雅服务而引致之任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的损失，正雅概不负责，亦不承担任何法律责任。",
    userAgreement250:
        " 2.5 用户承担正雅系统帐号与密码的保管责任，并就其帐号及密码项下之一切活动负全部责任。用户须重视正雅系统帐号、密码和公开邮箱的密码保护。用户不应将其帐号、密码转让、出售或出借予他人使用，若用户授权他人使用帐户，应对被授权人在该帐户下发生的所有行为负全部责任。正雅无法对非法或未经您授权使用您帐号及密码的行为做出甄别，因此正雅不承担任何责任。",
    userAgreement260:
        " 2.6 注册成为正雅用户后，如您连续12个月未使用您的该账号或未通过正雅公司认可的其他方式登录过您的账户，正雅齿科公司有权回收帐号，以免造成资源浪费，由此带来的损失由用户自行承担。本着有效利用正雅资源，保障更多合法用户权益为目的，对于恶意注册或者长期未登录系统帐号的，正雅有权回收。",
    userAgreement300: " 三、服务内容",
    userAgreement310: " 3.1 正雅系统服务的具体内容由正雅根据实际情况提供。",
    userAgreement320:
        " 3.2 除非本协议另有其他规定，正雅所推出的新功能、新服务，均受到本协议之规范。",
    userAgreement330:
        " 3.3 除正雅同意以外，用户不得对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。",
    userAgreement340:
        " 3.4 为使用本服务，您必须能够自行经有法律资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、数据机或其它存取装置。",
    userAgreement350:
        " 3.5 鉴于网络服务的特殊性，用户同意正雅有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。正雅不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。",
    userAgreement360:
        " 3.6 正雅有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，正雅对用户和任何第三人均不承担任何责任。",
    userAgreement400: " 四、责任承担",
    userAgreement410:
        " 4.1 用户违反本协议或相关服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括律师费，您同意赔偿正雅并使之免受损害。对此，正雅有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收其帐号、追究法律责任等措施。对恶意注册正雅帐号或利用正雅帐号进行违法活动、捣乱、骚扰、欺骗、其他用户以及其他违反本协议的行为，正雅有权回收其帐号。",
    userAgreement420:
        " 4.2 用户须对自己在使用正雅系统过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在正雅首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予正雅等额的赔偿。",
    userAgreement500: " 五、其他",
    userAgreement510:
        " 5.1 本协议的订立、履行和解释及争议的解决等，均应适用中华人民共和国法律。",
    userAgreement520:
        " 5.2 凡因本协议产生的或者与本协议有关的任何争议或者纠纷，双方应首先友好协商解决；协商不成的，双方约定向上海市浦东新区人民法院诉讼解决。",
    userAgreement530:
        " 5.3 本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。",
    userAgreement540:
        " 5.4 通过正雅矫正病例管理系统提交的订单，在发货后15天仍未接受到收货确认的，系统将默认已收货。",

    // "
    incompleteprompt: "您还有以下项目尚未填写，请填写完成后再提交",
    confirmcompleted: "以下病例信息已填写完成，请您确认后提交",
    suitablecases: "适用于深覆牙合浅覆盖病例",
    Zhongtong: "中通快递",
    Yuantong: "圆通快递",
    SFExpress: "顺丰快递",
    Shentong: "申通快递",
    best: "百世快递",
    postal: "邮政速递",
    daily: "天天快递",
    yunda: "韵达速递",
    homedelivery: "宅急送",
    speedlogistics: "优速物流",
    fullPeak: "全峰快递",
    forwordlaseont: "已到达最后一项",
    backtofirstone: "已到达第一项",
    haventPreview: "尚未生成预览,请保存基本信息后查看",
    haventchoseAngle: "尚未选择安氏分类",
    Wrongjawisnull: "错颌类型为空",
    WrongjawisSuccess: "错合类型暂存成功",
    storagesuccess: "暂存成功",
    haveNotyetcompleted: "存在尚未填写完整的信息,请检查后再进行提交",
    oldcasemanagementsystem: "访问旧病例管理系统V2.0",
    helpdocument: "帮助文档",
    videofile: "视频文件",
    confirmDelete: "确认删除?",
    deliverytimeforthisphase: "本阶段预计发货时间:",
    changeaddress: "如需变更收货地址请联系客服！",
    tipes: "上下颌步数不可同时为0",
    imagesfirsttip: "可批量上传照片，双击可删除",
    imageslasttip: "上传成功后,将照片拖拽到左侧对应位置中",
    toothtipe: "：红色代表乳牙，灰色代表缺牙",
    Resend: "后重新发送",
    ResendCode: "重新发送验证码",
    tipsMessage: "从2019.06.11起旧病例查看进V2.0系统!",
    pagefooterTips: "客服电话：021-50798880 E-Mail： case@smartee.cn",
    pagefooterTips1:
        " 地址：中国(上海)自由贸易试验区祖冲之路2305号122室二楼沪ICP备12307358号-1 / 沪公网安备156802014685号 / Powered by © 2015-2018 SMARTEE.CN",
    Startportsweep: "启动口扫",
    Viewmouthsweep: "查看口扫",
    Pleaseinformation: "请上传文件资料",
    entersteps: "请填写步数",
    NetworkError: "网络错误",
    Missingupperjaw: "缺失上颌",
    Missingjaw: "缺失下颌",
    Missingupperandlowerjaw: "缺失上下颌",
    canceledoperation: "您已取消操作",
    Nomouthscanfile: "没有口扫文件",
    notinstalled: "口扫软件未安装或安装路径不正确",
    Comingsoontonewcases: "即将转到新病例",
    Failed: "不合格",
    isloading: "正在加载中",
    filetyps: '以压缩包形式上传（文件类型必须是 .rar/.zip)'
};



// WEBPACK FOOTER //
// ./src/lang/zh.js